import React from 'react'
import styles from './MicrositeNotFoundSectionForm.module.css'
import TextInput from '../../../components/TextInput/TextInput'
import MicrositeImageUploader from '../../../components/MicrositeImageUploader/MicrositeImageUploader'

/**
 * MicrositeNotFoundSectionForm
 * Content editor for the microsite's 404 (page not found) screen —
 * heading, message, an optional illustration, and a "go home"
 * button. Pure presentational sub-form — receives `content` and
 * `onChange` from MicrositeLandingSection, which owns loading/
 * saving/versioning.
 *
 * content shape:
 *   { heading, message, illustration, ctaLabel, ctaUrl }
 */
const MicrositeNotFoundSectionForm = ({ content = {}, onChange }) => {
    const update = (field, value) => {
        onChange?.({ ...content, [field]: value })
    }

    return (
        <section className={styles.fieldGroup}>
            <h2 className={styles.groupTitle}>404 page</h2>
            <p className={styles.groupDesc}>Shown when a visitor lands on a page that doesn't exist.</p>

            <TextInput
                label="Heading"
                value={content.heading}
                onChange={(v) => update('heading', v)}
                placeholder="e.g. Oops, page not found"
                maxLength={80}
                showCharCount
            />

            <TextInput
                label="Message"
                value={content.message}
                onChange={(v) => update('message', v)}
                placeholder="e.g. The page you're looking for doesn't exist or has moved."
                maxLength={160}
                showCharCount
            />

            <MicrositeImageUploader
                label="Illustration (optional)"
                value={content.illustration}
                onChange={(v) => update('illustration', v)}
                placeholder="https://example.com/404-illustration.png"
            />

            <div className={styles.row2}>
                <TextInput
                    label="Button text"
                    value={content.ctaLabel}
                    onChange={(v) => update('ctaLabel', v)}
                    placeholder="Go to homepage"
                />
                <TextInput
                    label="Button link"
                    value={content.ctaUrl}
                    onChange={(v) => update('ctaUrl', v)}
                    placeholder="/"
                />
            </div>
        </section>
    )
}

export default MicrositeNotFoundSectionForm